import * as yup from 'yup';
import { Row, RenderConfig, Column, TextInput, EMPTY_ARRAY, SelectInput } from 'commons-ui';
import { onChangeConfigValAction } from './helper';

export const validationSchemaCreate = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	dailyLimit: yup.string().required('Daily Limit is required'),
	overAllLimit: yup.string().required('Overall Limit is required')
});

export const validationSchemaEdit = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	dailyLimit: yup.string().required('Daily Limit is required'),
	overAllLimit: yup.string().required('Overall Limit is required')
});

export const FORM_FIELD_KEYS = {
	SEGMENT_NAME: 'segmentName',
	DAILY_LIMIT: 'dailyLimit',
	OVERALL_LIMIT: 'overAllLimit'
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.SEGMENT_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.DAILY_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.OVERALL_LIMIT)])
	])
];

export const EDIT_GST_FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.SEGMENT_NAME)]),
		new Column([new Row(FORM_FIELD_KEYS.DAILY_LIMIT)]),
		new Column([new Row(FORM_FIELD_KEYS.OVERALL_LIMIT)])
	])
];

const sampleData: { [key: string]: string } = { id: '1', label: 'TEST' };

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.SEGMENT_NAME]: new RenderConfig()
		.setName('segmentName')
		.setLabel('Segment Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			options: [sampleData],
			required: true
		})
		.setToolTip('GST Segment Name'),
	[FORM_FIELD_KEYS.DAILY_LIMIT]: new RenderConfig()
		.setName('dailyLimit')
		.setLabel('Daily Limit(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			onChangeCallback: onChangeConfigValAction
		})
		.setToolTip('Gst Config Daily Limit'),
	[FORM_FIELD_KEYS.OVERALL_LIMIT]: new RenderConfig()
		.setName('overAllLimit')
		.setLabel('Overall Limit(₹)')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			onChangeCallback: onChangeConfigValAction
		})
		.setToolTip('Gst Config Overall Limit')
};

export const getFormDefaults = (segmentName: string, dailyLimit: number, overAllLimit: number) => {
	return {
		segmentName,
		dailyLimit,
		overAllLimit
	};
};
